import resume from "../assets/pdf/resume.pdf";

// export const headerData = {
//     name: 'Smruti Ranjan Dhal',
//     title: "Software Developer",
//     desciption:"Debugging is twice as hard as writing the code in the first place.Therfore, if you write the code as cleverly as possible, you are, by definition, not smart enough to debug it.  ",
//     // image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
//     image:'profile.png',
//     resumePdf: resume
// }
export const headerData = {
  name: "Smruti Ranjan Dhal",
  title: "Frontend/FullStack Developer",
  desciption:
    "Software Developer with 4.2+ years of experience building scalable, high-performance web applications using React.js, TypeScript, Redux, and modern frontend architectures. Proven success in enterprise delivery at Deloitte, optimizing UI performance, improving load times by up to 90%, and delivering reusable component-driven solutions in Agile environments.",
  image: "profile.png",
  resumePdf: resume,
};
